import React, {Component} from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter, Table} from 'reactstrap';
import {toast} from 'react-toastify';

import {getUser, getPermission} from "../../utils/TokenManager";
import {ACHIEVEMENT_CORRECTION} from "../common/Constants";
import ErrorMsg from "../common/ErrorMsg";
import loadingGIF from "../../public/assets/images/loading.gif";
import {CORRECTION_STATUS, UPDATED, DELETED} from "./Constants";
import CorrectionForm from "./CorrectionForm";


export default class CorrectionLog extends Component {
    state = {
        refreshStaffdata: false,
        selectedRows: {},
        isLoading: false
    };

    auth = {
		user: getUser(),
        permission: getPermission()[ACHIEVEMENT_CORRECTION],
	}

    componentDidMount = () => {
        this.getInitialState();
    };

    getInitialState = async () => {
        if (this.auth.permission.can_view) {
            const {selectedUser} = this.props;
            this.setState({isLoading: true});
            try {
                await this.props.getCorrectionDataList(selectedUser.id);
            } catch (error) {
                toast.error(<ErrorMsg errors={error}/>);
            }
            this.setState({isLoading: false});
            return false;
        }
    };

    setRefreshStatus = (shouldRefresh) => {
        this.setState({refreshStaffdata: shouldRefresh});
    }

    toggleModal = () => {
        this.props.toggleModal(this.state.refreshStaffdata);
    };


    getRequestDetails = async (request) => {
        const {selectedRows} = this.state;
        this.setState({
            selectedRows: {...selectedRows, [request.id]: !selectedRows[request.id]}
        });
    };

    render() {
        const {selectedRows, isLoading} = this.state;
        const {staffData, staffDashboard, selectedKPI} = this.props;
        
        // Load request list
        let requestListData = [];
        staffData.correctionDataList.filter(request => {
            let requestRow = <React.Fragment key={request.id}>
                <tr onClick={() => this.getRequestDetails(request)}
                    className={`cursor-pointer text-white border ${
                        request.status === UPDATED ? 
                            selectedRows[request.id] ? "bg-success border-success" 
                            : "text-success" 
                        : request.status === DELETED ? 
                            selectedRows[request.id] ? "bg-danger border-danger" 
                            : "text-danger" 
                        : selectedRows[request.id] ? "bg-dark border-dark" : "text-dark"
                    }`} 
                >
                    <td>{request.kpi_name}</td>
                    <td>{request.added_on}</td>
                    <td>{request.requested_on}</td>
                    <td>{CORRECTION_STATUS[request.status]}</td>
                    <td>{request.approved_on}</td>
                    <td className="align-middle" style={{width: "20px"}}>
                        <i className={`fa ${
                            selectedRows[request.id] ? "fa-caret-up" : "fa-caret-down"
                        }`} 
                        ></i>
                    </td>
                </tr>
                {selectedRows[request.id] &&
                    <tr>
                        <td colSpan="6" 
                            className={`border ${
                                request.status === UPDATED ? "border-success" :
                                request.status === DELETED ? "border-danger" : "border-dark"
                            }`}
                        >
                            <CorrectionForm {...this.props}
                                setRefreshStatus={this.setRefreshStatus}
                                request={request}
                                canEdit={this.auth.permission.can_edit}
                                canDelete={this.auth.permission.can_delete}
                            />
                        </td>
                    </tr>
                }
            </React.Fragment>;
            if (staffDashboard && selectedKPI.kpi_list_id) {
                if (request.kpi_id === selectedKPI.kpi_list_id) {
                    requestListData.push(requestRow);
                    return true;
                }
                return false;
            }
            requestListData.push(requestRow);
            return true;
        });

        return (
            <Modal isOpen={this.props.modal} toggle={this.toggleModal} size="lg">
                <ModalHeader toggle={this.toggleModal}>
                    Request Corrections Log
                </ModalHeader>
                <ModalBody>
                    {this.auth.permission.can_view &&
                        <Table striped className="mb-0 bg-white border" size="sm">
                            <thead className="border-bottom bg-warning">
                                <tr className="border border-warning">
                                    <th className="font-weight-bold font-16">KPI Name</th>
                                    <th className="font-weight-bold font-16">Date</th>
                                    <th className="font-weight-bold font-16">Requested on</th>
                                    <th className="font-weight-bold font-16">Status</th>
                                    <th className="font-weight-bold font-16">Approved on</th>
                                    <th style={{width: "20px"}}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {requestListData}
                            </tbody>
                        </Table>
                    }
                    {isLoading &&
                        <p className="loading-gif">
                            <img src={loadingGIF} alt="Loading..." width="32" height="32"/>
                        </p>
                    }
                </ModalBody>
                <ModalFooter>
                    <Button className='btn btn-secondary' onClick={this.toggleModal}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/staffData/CorrectionsLog.js